import Stats from "components/Stats";

function StatisticPage() {
  return <Stats />;
}

export default StatisticPage;
